import axios from "axios";
import { api } from "~/router/apiConfig";

export function indexGrafana(contractId, request) {
  return axios.get(
    api.path("contractMetric.grafana_index", { contractId: contractId }),
    request
  );
}
